import React, { useEffect, useState } from "react";
import { Input, NumberInput } from "../plain-inputs";
import { AsyncTypeahead } from "../typeahead";

export const MeasurementInputNew = ({
    id,
    name,
    defaultValue,
    dataType,
    valueAsString,
    stringPattern = "^[-+<>]?[0-9]*\\.?[0-9]+$",
    filter,
    lengthRestriction = false,
    updateOnChange,
}) => {
    const [measurement, setMeasurement] = useState({
        value: defaultValue || defaultValue === 0 ? defaultValue.value : "",
        uom: defaultValue ? defaultValue.uom : "",
    });

    useEffect(() => {
        setMeasurement({
            value: defaultValue || defaultValue === 0 ? defaultValue.value : "",
            uom: defaultValue ? defaultValue.uom : "",
        });
    }, [defaultValue]);

    const onUomFieldUpdate = (fieldName, value) => {
        const uom = value ? value : "";
        setMeasurement({
            ...measurement,
            uom,
        });

        reportUp(measurement.value, uom);
    };

    const onInputFieldUpdate = (fieldName, value) => {
        setMeasurement({
            ...measurement,
            value,
        });

        reportUp(value, measurement.uom);
    };

    const reportUp = (value, uom) => {
        updateOnChange(
            name,
            {
                value,
                uom,
            },
            dataType
        );
    };

    const VariableInput = valueAsString ? Input : NumberInput;
    const hasPattern = valueAsString ? stringPattern : null;
    const uniqueId = id || name;

    return (
        <div className="measurement-input-group">
            <div className="form-field -small">
                <VariableInput
                    id={`number_${uniqueId}`}
                    value={measurement.value}
                    updateOnChange={onInputFieldUpdate}
                    className="-small"
                    pattern={hasPattern}
                />
            </div>
            <div className="form-field">
                <AsyncTypeahead
                    id={`uom_${uniqueId}`}
                    name={name}
                    defaultValue={measurement.uom}
                    updateOnChange={onUomFieldUpdate}
                    tags={filter}
                    provider="/picklists/MetricServingSizeUomNew"
                    creatable={false}
                    lengthRestriction={lengthRestriction}
                />
            </div>
        </div>
    );
};
